import Vue from 'vue';

export default {
  MASK_EVENT_ID(state, { pseudoId, id }) {
    Vue.set(state.masked_event_ids, id, pseudoId)
    // Same as state.masked_event_ids[id] = pseudoId, but with reactivity
  },
  UNMASK_EVENT_ID(state, id) {
    Vue.delete(state.masked_event_ids, id)
    // Same as delete state.masked_event_ids[id], but with reactivity
  },
  RESET_MASKED_EVENTS(state) {
    state.masked_event_ids = [];
  },
  TOGGLE_AUTO_TRIGGER(state) {
    state.optimizer_auto_trigger = !state.optimizer_auto_trigger;
  },
  SET_OPTIMIZER_STATE(state, value) {
    if ( [ 'not_triggered', 'waiting', 'running', 'fail', 'success' ].includes(value) ) {
      state.optimizer_state = value;
    } else {
      throw new Error('Invalid state name', value)
    }
  },
  SET_OPTIMIZER_RESULT(state, data) {
    state.optimizer_result = data;
  },
  SET_OPTIMIZER_RESPONSE_TIME(state, value) {
    state.optimizer_response_time = value;
  },
  SET_OPTIMIZER_USER_ERROR(state, error) {
    state.optimizer_user_error = error;
  },
  SELECT_OPTIMIZER_ALGORITHM(state, algorithm) {
    state.optimizer_algorithm = algorithm;
  },
  SET_PLANNING_HORIZON(state, data) {
    console.log('SET_PLANNING_HORIZON', data.planning_horizon)
    state.optimizer_planning_horizon = data.planning_horizon;
  },
  RESET(state) {
    state.optimizer_running = false;
    state.optimizer_auto_trigger = true;
    state.optimizer_result.finishDatesTasks = {};
    state.optimizer_result.finishDatesCommmitments = {};
    state.optimizer_state = 'not_triggered';
    state.optimizer_response_time = -1;
    state.optimizer_user_error = '';
    state.masked_event_ids = [];
    state.optimizer_algorithm = 'goalpilot_action_plan_v3';
    state.optimizer_planning_horizon = 2;
  },

  SET_MANUAL_DAYPLAN(state, { date, dayplan }) {
    // date = 'YYYYMMDD'
    // dayplan = []
    //console.log('SET_MANUAL_DAYPLAN', dayplan)
    //state.optimizer_manual_dayplan[ date ] = dayplan
    Vue.delete( state.optimizer_manual_dayplan, date )
    Vue.set( state.optimizer_manual_dayplan, date, dayplan )
  },

  SET_MANUAL_DAYPLAN_ITEM(state, { date, index, item }) {
    // date = 'YYYYMMDD'
    // index = 0,1,2
    // item = {...}
    Vue.set( state.optimizer_manual_dayplan[ date ], index, item )
  },
}
